import QueryLine from '@/components/query2/query-line';

export default class QueryCollection {
    static DefaultLineCount = 1;

    /**
     * Initialize a query collection for UI enumeration.
     * @param {[]|{}} query
     * @param {boolean=false} isCriteria
     * @param {?FilterSet} filterSet
     */
    constructor({query = [], isCriteria = false, filterSet = null} = {}) {
        this.query = query;
        this.isCriteria = isCriteria;
        this.filterSet = filterSet;
        /**
         * @type {QueryLine[]}
         */
        this.items = [];
        this.populate(this.query);
    }

    /**
     * Add a query line to the item collection.
     * @param {?QueryLine} line
     */
    addItem(line = null) {
        this.items.push(line || new QueryLine({isNewlyAdded: true}));
    }

    /**
     * Remove an query line from the collection.
     * @param {number} index
     */
    removeItem(index) {
        this.items.splice(index, 1);
    }

    /**
     * Check whether the collection has items.
     * @return {boolean}
     */
    get hasItems() {
        return this.items.length > 0;
    }

    /**
     * Reset the collection items back to an empty state.
     */
    resetItems() {
        this.items = [];
    }

    /**
     * Populate the collection from the query. The handling of criteria and filters is done
     * differently.
     * @param {?[]|?{}} query
     */
    populate(query = null) {
        this.resetItems();
        if (!query) {
            // insert default lines
            if (this.isCriteria) {
                // TODO
            } else {
                this.items = Array.from(
                    new Array(QueryCollection.DefaultLineCount),
                    () => new QueryLine(),
                );
            }
        } else {
            const {isCriteria} = this;
            if (Array.isArray(query) && !isCriteria) {
                if (query.length === 0) {
                    // add an empty line
                    this.addItem();
                } else {
                    query.forEach(line => this.addItem(new QueryLine({
                        line,
                        isCriteria,
                        filterSet: this.filterSet,
                    })));
                }
            } else if (this.isCriteria) {
                // TODO
            }
        }
    }

    /**
     * Get all pointers currently active within the collection. Used for populating
     * the lists of pointer options available in other items of the collection.
     * @return {string[]}
     */
    get selectedPointers() {
        return this.items
            .reduce((result, {pointer}) => (pointer ? [...result, pointer] : result), []);
    }

    /**
     * Get the payload for the query collection into in array for filters
     * or an object for criteria.
     * @return {*[]|Array}
     */
    getPayload() {
        if (this.hasItems) {
            if (this.isCriteria) {
                // TODO add support for criteria
            }
            const result = this.items
                .map(item => item.getPayload())
                .filter(item => item !== null);
            if (result.length) {
                return result;
            }
        }
        return [];
    }
}
